import { Theme } from '@mui/material';

import { muiCharts } from './MuiCharts';
import { muiDataGrid } from './MuiDataGrid';
import { muiDateRangePicker } from './MuiDateRangePicker';
import { muiFormControl } from './MuiFormControl';
import { muiFormLabel } from './MuiFormLabel';
import { muiGrid } from './MuiGrid';
import { muiMenu } from './MuiMenu';
import { muiPopper } from './MuiPopper';
import { muiSnackbar } from './MuiSnackbar';

export const components: Theme['components'] = {
  ...muiMenu,
  ...muiCharts,
  ...muiDataGrid,
  ...muiDateRangePicker,
  ...muiFormControl,
  ...muiFormLabel,
  ...muiGrid,
  ...muiPopper,
  ...muiSnackbar,
};
